import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from "@chakra-ui/react";
import { useCallback, useState } from "react";
import { checkForDuplicatePhrase, createPhrase } from "../db";

interface AddPhraseDialogProps {
  isOpen: boolean;
  onClose: () => void;
  updatePhrases: () => void;
}

const AddPhraseDialog = ({
  isOpen,
  onClose,
  updatePhrases,
}: AddPhraseDialogProps) => {
  const [phrase, setPhrase] = useState<string>("");
  const [phraseEmoji, setPhraseEmoji] = useState<string>("");
  const [invalid, setInvalid] = useState<boolean>(false);
  const [invalidMessage, setInvalidMessage] = useState<string>("");

  const addPhrase = useCallback(
    async (phrase: string, emoji?: string) => {
      if (!phrase) {
        setInvalidMessage("Phrase cannot be empty.");
        return setInvalid(true);
      }
      if (await checkForDuplicatePhrase(phrase)) {
        setInvalidMessage("Phrase already exists.");
        return setInvalid(true);
      }
      await createPhrase(phrase, emoji);
      await updatePhrases();
      onClose();
    },
    [onClose, updatePhrases]
  );

  const handleSubmit = (e: any) => {
    e.preventDefault();
    addPhrase(phrase, phraseEmoji);
  };

  const onPhraseChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value) {
      setInvalid(false);
    }
    setPhrase(e.target.value);
  };

  const onPhraseEmojiChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhraseEmoji(e.target.value);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add phrase</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box as="form" onSubmit={handleSubmit}>
            <VStack>
              <FormControl>
                <FormLabel>Phrase</FormLabel>
                <Input
                  type="text"
                  value={phrase}
                  onChange={onPhraseChange}
                  isInvalid={invalid}
                />
                <FormHelperText>
                  Enter new phrase. {invalid && invalidMessage}
                </FormHelperText>
              </FormControl>

              <FormControl>
                <FormLabel>Phrase emoji</FormLabel>
                <Input
                  type="text"
                  value={phraseEmoji}
                  onChange={onPhraseEmojiChange}
                />
                <FormHelperText>
                  Enter phrase emoji (optional). {invalid && invalidMessage}
                </FormHelperText>
              </FormControl>
            </VStack>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="blue"
            onClick={() => addPhrase(phrase, phraseEmoji)}
          >
            Add
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddPhraseDialog;
